/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';


/**
 * @export
 * @class QueryViewDataContainerComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-query-view-data-container',
  templateUrl: './query-view-data-container.component.html',
  styleUrls: ['./query-view-data-container.component.scss']
})
export class QueryViewDataContainerComponent {
  @Input() searchType;
  @Input() searchResult;
  hideTable: Boolean = true;
  @Output() showLocoMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() showTrainMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() loadData: any;
  constructor(private lmsLoaderService: LmsLoaderService) {

    this.lmsLoaderService.isLoading.subscribe((data) => {
      this.hideTable = data;
    });
  }
}
